import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiArrowLeft, FiClock, FiMapPin } from 'react-icons/fi';
import './UserLogs.css';

const UserLogs = () => {
  const { userId } = useParams();
  const [logs, setLogs] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
    fetchUser();
  }, [userId]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`/api/users/${userId}/`);
      setUser(response.data);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  const fetchLogs = async () => {
    try {
      const response = await axios.get(`/api/users/logs/?user_id=${userId}`);
      setLogs(response.data.results || response.data);
    } catch (error) {
      toast.error('Ошибка загрузки логов');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="user-logs-page">
      <div className="page-header">
        <Link to="/users" className="back-link">
          <FiArrowLeft /> Назад к пользователям
        </Link>
        <h1>Логи пользователя: {user?.email || 'Загрузка...'}</h1>
      </div>

      <div className="logs-container">
        <table className="table">
          <thead>
            <tr>
              <th>Дата и время</th>
              <th>Действие</th>
              <th>IP адрес</th>
              <th>Страна</th>
              <th>Город</th>
              <th>Детали</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log) => (
                <tr key={log.id}>
                  <td>
                    <div className="log-time">
                      <FiClock />
                      {new Date(log.created_at).toLocaleString('ru-RU')}
                    </div>
                  </td>
                  <td>
                    <span className="action-badge">{log.action}</span>
                  </td>
                  <td>{log.ip_address}</td>
                  <td>
                    {log.country && (
                      <div className="geo-info">
                        <FiMapPin />
                        {log.country}
                      </div>
                    )}
                  </td>
                  <td>{log.city || '-'}</td>
                  <td>
                    {log.details && Object.keys(log.details).length > 0 ? (
                      <details className="log-details">
                        <summary>Детали</summary>
                        <pre>{JSON.stringify(log.details, null, 2)}</pre>
                      </details>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="empty-state">
                  <p>Нет логов для этого пользователя</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserLogs;
